import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { Entrar } from '@/features/auth/componentes/Entrar';
import { lerSessao } from '@/features/auth/guardas';
import { destinoDepoisDoLogin } from '@/features/auth/sessao';

const busca = z.object({
  volta: z.string().optional(),
  aviso: z.enum(['sessao-expirada', 'senha-criada', 'senha-redefinida', 'so-aluno']).optional(),
});

export const Route = createFileRoute('/entrar')({
  validateSearch: busca,
  beforeLoad: async ({ context, search }) => {
    // Com sessão válida, vai direto para o painel (CA-06).
    const me = await lerSessao(context);
    if (me === null) return;
    const destino = destinoDepoisDoLogin(me, search.volta);
    if (destino.tipo === 'ir') throw redirect({ href: destino.para, replace: true });
  },
  component: PaginaEntrar,
});

function PaginaEntrar() {
  const { volta, aviso } = Route.useSearch();
  return <Entrar volta={volta} aviso={aviso} />;
}
